exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{overflow:scroll}[dir] body{background-color:#fff!important}", ""]);

// exports
